import { validateGoalExplosionDefinition } from '../effects/MatchEffectsDefinition';
import { MAX_GOAL_EXPLOSION_SELECTION } from '../../inventory/InventoryContracts';
import type { GoalExplosionDefinition } from '../effects/MatchEffectsDefinition';
import type { GoalExplosionSelectionMode } from '../../inventory/InventoryContracts';

export interface ResolvedGoalExplosionLoadout {
  readonly version: number;
  readonly selectionMode: GoalExplosionSelectionMode;
  readonly items: readonly Readonly<{
    itemId: string;
    revision: number;
    definition: GoalExplosionDefinition;
  }>[];
}

export interface GoalExplosionLoadoutResolver {
  resolveGoalExplosionLoadout(userId: string | null): Promise<ResolvedGoalExplosionLoadout>;
}

export function validateResolvedGoalExplosionLoadout(value: ResolvedGoalExplosionLoadout): void {
  if (!value || !Number.isSafeInteger(value.version) || value.version < 0
    || (value.selectionMode !== 'shuffle-bag' && value.selectionMode !== 'random')
    || !Array.isArray(value.items) || value.items.length > MAX_GOAL_EXPLOSION_SELECTION) {
    throw new Error('Invalid goal explosion loadout.');
  }
  const ids = new Set<string>();
  for (const item of value.items) {
    if (!item || typeof item.itemId !== 'string' || !UUID.test(item.itemId)
      || !Number.isSafeInteger(item.revision) || item.revision < 1 || ids.has(item.itemId.toLowerCase())) {
      throw new Error('Invalid goal explosion loadout item.');
    }
    ids.add(item.itemId.toLowerCase());
    validateGoalExplosionDefinition(item.definition);
  }
}
const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
